import "bootstrap-vue/dist/bootstrap-vue.css";
import moment from "moment";
import planningService from "@/services/planning";
import Utils from "@/mixins/Utils";
export default {
  props: {
    intervention: {
      type: Object,
      required: true,
    },
  },
  mixins: [Utils],
  data() {
    return {
      startTime: null,
      endTime: null,
      interventionData: {},
      newStartDate: null,
      newEndDate: null,
      spinner_variable: {
        spinnerMounted: false,
      },
      timeLabels: {
        labelHours: "Heures",
        labelMinutes: "Procès-verbal",
        labelSeconds: "Des secondes",
        labelIncrement: "Lever",
        labelDecrement: "Diminution",
        labelSelected: "Temps sélectionné",
        labelNoTimeSelected: "Pas de temps choisi",
        labelCloseButton: "Fermer",
      },
    };
  },
  computed: {
    errorCompareTime() {
      if (
        moment(
          new Date(`${this.newEndDate} ${this.endTime}`).getTime()
        ).isAfter(new Date(`${this.newStartDate} ${this.startTime}`).getTime())
      ) {
        return;
      }
      return this.$t("error-compare-time");
    },
  },
  created() {
    this.newStartDate = moment(this.intervention.start, "x").format(
      "YYYY-MM-DD"
    );
    this.newEndDate = moment(this.intervention.end, "x").format(
      "YYYY-MM-DD"
    );
    this.startTime = this.$options.filters.formatUnixHeure(
      this.intervention.start
    );
    this.endTime = this.$options.filters.formatUnixHeure(this.intervention.end);
  },
  methods: {
    async save() {
      const vue = this;
      this.$validator.validateAll().then(async (result) => {
        if(!result) return
        if (vue.errorCompareTime) return;
        vue.spinner_variable.spinnerMounted = true;
        const submitData = {
          ...vue.interventionData,
          idMission: this.intervention.idMission,
          newDateStart: new Date(
            `${vue.newStartDate} ${vue.startTime}`
          ).getTime(),
          newDateEnd: new Date(`${vue.newEndDate} ${vue.endTime}`).getTime(),
        };
        await planningService
          .createModificationRequest(submitData)
          .then((res) => {
            if (res.success) {
              vue.spinner_variable.spinnerMounted = false;
              vue.callToaster(vue.$t("modification-saved"));
              const data = {
                idMission: submitData.idMission,
                message: submitData.message,
                newStartDate: submitData.newDateStart,
                newEndDate: submitData.newDateEnd
              }
              vue.$emit("saved", data);
            } else {
              vue.spinner_variable.spinnerMounted = false;
              vue.callToaster(response.data.message);
            }
          })
          .catch((err) => {
            vue.callToaster(vue.$t("problem-arise"));
          });
      });
    },
  },
};
